const stateManager = require("../../../utils/state/stateManager");
const snoozeAction = require("../../../utils/state/actions/snooze/snoozeAction");
const jobsServer = require("../../../utils/jobs/jobsServer");
const rmsApiProxyRetry = require("../../../utils/api/rmsApiProxyRetry");
const guidUtil = require("../../../utils/guid/guidUtil");
const logger = require("../../../utils/logger/logger");
const dateUtil = require('../../../utils/dateUtil/dateUtil.js');

export function updateSnoozeState(allTypeSnoozes = [], type) {
     if (typeof type === "undefined") throw new Error("type not provided");

     const snoozes = stateManager.getStore().getState().snoozes;

     const newSnoozeState = snoozes.filter((snooze) => snooze.type !== type);

     allTypeSnoozes.forEach((snoozeTag) => {
          if (snoozeTag.type === type && snoozeTag.isSnoozed) {
               newSnoozeState.push(snoozeTag);
          }
     });

     stateManager.getStore().dispatch(snoozeAction.createAction(newSnoozeState));
}

export function addJobForSnooze(changedSnoozes = [], type) {
    if (typeof type === "undefined") throw new Error("type not provided");
    if (changedSnoozes.length === 0) return;

    jobsServer.addJob(guidUtil.generateGuid(), `BatchJobs.Snooze`, () => {
          try {
               logger.info(`Publishing ${type} snoozed`);
               var resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/snooze`;
               rmsApiProxyRetry.post(resource, changedSnoozes);
               logger.info(`Snoozed ${type} submitted successfully`);
          } catch (error) {
               logger.error(`Error occurred while submitting ${type} snoozed. ${error}`, {}, error);
          }
     });
}


export function calculateExpiry(expiryCaption)
{
    let selectedExpiry;
    switch (expiryCaption)
    {
        case "Today":
            selectedExpiry = dateUtil.getToday();
            selectedExpiry = dateUtil.setHours(selectedExpiry, 23);
            selectedExpiry = dateUtil.setMinutes(selectedExpiry, 59);
            break;
        case "OneHour":
            selectedExpiry = dateUtil.getNow();
            selectedExpiry = dateUtil.addHours(selectedExpiry, 1);
            break;
        case "TwoHour":
            selectedExpiry = dateUtil.getNow();
            selectedExpiry = dateUtil.addHours(selectedExpiry, 2);
            break;
        case "FourHour":
            selectedExpiry = dateUtil.getNow()
            selectedExpiry = dateUtil.addHours(selectedExpiry, 4);
            break;
        case "TwoDays":
            selectedExpiry = dateUtil.getToday();
            selectedExpiry = dateUtil.setHours(selectedExpiry, 23);
            selectedExpiry = dateUtil.setMinutes(selectedExpiry, 59);
            selectedExpiry = dateUtil.addDays(selectedExpiry, 1);
            break;
        case "ThreeDays":
            selectedExpiry = dateUtil.getToday();
            selectedExpiry = dateUtil.setHours(selectedExpiry, 23);
            selectedExpiry = dateUtil.setMinutes(selectedExpiry, 59);
            selectedExpiry = dateUtil.addDays(selectedExpiry, 2);
            break;
        case "Manual":
            selectedExpiry = "-1";
            break;
        default:
            selectedExpiry = null;
    }
    return selectedExpiry;
}